export const ListQueryKey = 'autoTransConfigs';
export const DetailQueryKey = 'autoTransConfig';
export const Urls = {
  selectUrl: '/AutoTransConfig/list',
  updateUrl: '/AutoTransConfig/update',
  deleteUrl: '/AutoTransConfig/delete',
  createUrl: '/AutoTransConfig/create',
  detailUrl: '/AutoTransConfig/info'
};